import { add, format } from 'date-fns';

export const DEFAULT_START_TIME = '10:00';
export const DEFAULT_END_TIME = '12:00';

const DAYS_OFFSET_FOR_STARTING_DATE = 40;

export const formatDateTimeLocal = (date: Date) => {
    return format(date, "yyyy-MM-dd'T'HH:mm");
};

/**
  These two functions below are not in use. But I'll leave them for mobile data conversion when using two different data for desktop/mobiles.

export const composeDateTime = ({
    date,
    time,
}: {
    date: string;
    time: string;
}) => `${date}T${time}`;

export const decomposeDateTime = (datetime: string) => {
    const [date, time] = datetime.split('T');

    return {
        date,
        time,
    };
};
*/

export const formatDate = (date: Date) => format(date, 'yyyy-MM-dd');

export const getDefaultDateWithOffset = () => {
    const dateNow = new Date();
    const dateWithOffset = add(dateNow, {
        days: DAYS_OFFSET_FOR_STARTING_DATE,
    });

    return dateWithOffset;
};

const defaultDate = getDefaultDateWithOffset();

export const getDefaultEventDate = () => formatDate(defaultDate);

/**
  Not in use, but I'll leave it for mobile data conversion when using two different data for desktop/mobiles.

 export const getDefaultStartDateTime = () => formatDateTimeLocal(defaultDate);

 export const getDefaultEndDateTime = () => {
     const startDate = new Date(defaultDate);
     const dateTimeWithOffset = add(startDate, {
         hours: HOURS_OFFSET_FOR_STARTING_TIME,
     });

     return formatDateTimeLocal(dateTimeWithOffset);
 };

 */
